import axios from 'axios';

export const getWorkPositions = async (departmentId, lang) => {
  const { data } = await axios.get(`/company-departments/${departmentId}/work-positions?lang=${lang}`);

  return data.sort((a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()));
};
